import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {PathService} from "./path.service";
import {Observable} from "rxjs";
import {IdInfo, OkInfo} from "../util/interfaces";
import {map} from "rxjs/operators";

export type InstitutionType = 'Educational' | 'Government' | 'Corporate' | 'Nonprofit' | 'Other';

export interface Address {
    street: string;
    street_2?: string;
    city: string;
    state: string;
    zip: string;
}

export interface Institution {
    id?: number;
    created?: string;
    updated?: string;
    name: string;
    type: InstitutionType;
    address: Address;
    contactName: string;
    contactRole?: string;
    contactEmail: string;
    contactPhone?: string;
    notificationEmail?: string;
    promoPrefix: string;
    notes?: string;
    needShipping?: boolean;
    prescriberId?: number;
    labId?: number;
}

type InstitutionsResult = { institutions: Institution[] };

export interface InstOrder {
    id?: number;
    institution_id?: number;
    created?: string;
    updated?: string;
    promo_id?: number;
    promo_code?: string;
    promo_expires?: string;
    promo_inventory?: number;
    promo_disabled?: boolean;
    product_id?: number;
    unit_count?: number;
    unit_price?: number;
    discount?: number;
    discount_description?: string;
    charges?: number;
    charges_description?: string;
    total?: number;
    notes?: string;
    paid?: string;
    payment_info?: any;
}

type OrdersResult = { orders: InstOrder[] };

@Injectable({
    providedIn: 'root'
})
export class InstService {

    readonly instRoot: string;

    constructor(private http: HttpClient, 
                private pathService: PathService) {
        this.instRoot = `${this.pathService.apiRoot}/inst`;
    }
    
    getAll(): Observable<Institution[]> {
        return this.http.get<InstitutionsResult>(this.instRoot).pipe(
            map((out) => out.institutions)
        );
    }

    add(inst: Institution): Observable<IdInfo> {
        return this.http.post<IdInfo>(this.instRoot, inst);
    }

    update(inst: Institution): Observable<OkInfo> {
        return this.http.put<OkInfo>(this.instRoot, {institution: inst});
    }

    getAllOrders(instId: number): Observable<InstOrder[]> {
        return this.http.get<OrdersResult>(`${this.instRoot}/${instId}/orders`).pipe(
            map((out) => out.orders)
        );
    }

    addOrder(instId: number, order: InstOrder): Observable<IdInfo> {
        return this.http.post<IdInfo>(`${this.instRoot}/${instId}/orders`, order);
    }

    updateOrder(instId: number, order: InstOrder): Observable<OkInfo> {
        return this.http.put<OkInfo>(`${this.instRoot}/${instId}/orders`, order);
    }
}
